// extracted by mini-css-extract-plugin
export default {"stripedRow":"GheTargetAnalogueTable_stripedRow__4jGOA","table":"GheTargetAnalogueTable_table__UgIig"};